import React from "react";
import { createStyles, DialogTitle, makeStyles } from "@material-ui/core";
import Dialog from "components/Dialog";
import LoseImage from "assets/images/lose.png";
import Confettis from "./Confettis";

export const useStyles = makeStyles(() =>
  createStyles({
    giftImage: {
      height: "100%",
      width: "100%",
      objectFit: "contain",
    },
  })
);

interface GiftInfoDialogProps {
  open: boolean;
  giftImage?: string;
  giftWon: boolean;
  handleCloseModal: () => void;
}

function GiftInfoDialog({ open, giftWon, handleCloseModal, giftImage }: GiftInfoDialogProps) {
  const classes = useStyles();
  const handleClose = () => {
    handleCloseModal();
  };

  const Congratulations = () => <img src={giftWon ? giftImage : LoseImage} className={classes.giftImage} />;

  return (
    <>
      <Confettis show={open && giftWon} />
      <Dialog
        open={open}
        maxWidth="sm"
        height="600px"
        customDialogTitle={<DialogTitle style={{ display: "none" }} />}
        customBackground={` overflow-y: inherit;
          color:white;
          background-color: #1a224b;
          padding:0 !important;
          text-align: center;`}
        handleClose={handleClose}
        noPadding
        hideActions
      >
        <Congratulations />
      </Dialog>
    </>
  );
}

export default GiftInfoDialog;
